import React, { FC, useState } from 'react'
import { Trans, t } from '@lingui/macro'

import { OrientationEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { ButtonClean, ButtonPrimary, Modal } from 'front-end/src/components'

import Form, { FormRow } from '../../../components/common/form/Form'
import Label from '../../../components/common/form/label/Label'
import Input from '../../../components/common/form/input/Input'
import Select from '../../../components/common/select/Select'
import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { useCreateCertificateTemplateMutation } from './NewTemplateModal.codegen'

interface IProps {
  show: boolean
  onHide: () => void
  onSubmit: () => void
}

const OrientationOptions = [
  OrientationEnum.HORIZONTAL,
  OrientationEnum.VERTICAL,
  OrientationEnum.SQUARE
].map((o) => ({
  label: o,
  value: o
}))

export const NewTemplateModal: FC<IProps> = ({ show, onHide, onSubmit }) => {
  const [createTemplateFn] = useCreateCertificateTemplateMutation()
  const [name, setName] = useState('')
  const [selectedOrientation, setSelectedOrientation] = useState<{
    value: OrientationEnum
    label: OrientationEnum
  }>({
    value: OrientationEnum.HORIZONTAL,
    label: OrientationEnum.HORIZONTAL
  })

  const onSend = async () => {
    const result = await createTemplateFn({
      variables: {
        input: {
          name,
          orientation: selectedOrientation.value
        }
      }
    })

    const id = result.data?.admin?.organisation?.createCertificateTemplate?.id

    if (id) {
      navigateTo(linkBuilder.certificationsTemplates(id))
    }

    onSubmit()
  }

  return (
    <Modal
      show={show}
      header={t`Create a new certification template`}
      onHide={onHide}
      controls={
        <>
          <ButtonClean onClick={onHide}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary onClick={onSend}>
            <Trans>Create</Trans>
          </ButtonPrimary>
        </>
      }
    >
      <Form onSubmit={onSend}>
        <FormRow>
          <Label htmlFor="name">
            <Trans>Name of the template</Trans>
          </Label>
          <Input
            fullWidth
            id="name"
            onChange={(val: string): void => {
              setName(val)
            }}
            value={name}
          />
        </FormRow>
        {/* Dimensions are not implemented for now, will get back to it after integrating react-designer */}
        <FormRow>
          <Label htmlFor="orientation">
            <Trans>Orientation</Trans>
          </Label>
          <div style={{ maxWidth: '280px' }}>
            <Select
              name="orientation"
              value={selectedOrientation}
              options={OrientationOptions}
              onChange={async (selected) => {
                // @ts-expect-error 9/11/2020
                setSelectedOrientation(selected)
              }}
              className="CertificateSection__Select"
              placeholder={t`Select...`}
            />
          </div>
        </FormRow>
      </Form>
    </Modal>
  )
}
